import React from 'react';
import { Footer } from '../../../components/footer';
import Loader from '../../Loader/buttonLoad';
import { useStakeDetails } from '../stakingwallet/api';
import { formatBalance } from '../../../hook/bigNumber';
import { Link, useNavigate } from 'react-router-dom';


const RedeemWallet = () => {

    const { data: stakeBalance, isLoading } = useStakeDetails()
    const navigate = useNavigate()



    const redeemWalletTabs = [
        { tabName: 'Swap', navigationto: '/swap' },
        { tabName: 'Move Stake Wallet', navigationto: '/move-to-stake-wallet' },
        { tabName: 'Stake Reward', navigationto: '/stake-rewards' },
        { tabName: 'Global Reward', navigationto: '/global-rewards' },
        { tabName: 'Airdrop', navigationto: '/air-drop' },
        { tabName: 'ICO Referral Income', navigationto: '/ico-referral-income' },
        { tabName: 'Auto Stake Income', navigationto: '/auto-stake-income' },
        { tabName: 'Move Stake Income', navigationto: '/move-to-stake-income' },
        { tabName: 'From Stake', navigationto: '/from-stake' },
    ]

    return (
        <>
            <div className="mainContent">
                {(isLoading) && <Loader />}

                <div className="pageContent def-py-30">

                    <div className='container'>
                        <div className="appPagetitle"><button className='btn btnBack' onClick={() => navigate('/dashboard')}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button> Redeem Wallet</div>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 p-4">
                                    <div className="row align-items-center">
                                        <div className="col-lg-4">
                                            <div className='d-flex g-15 align-items-center mb-lg-0 mb-3'>
                                                <div className='masterWalletIcon animate__animated animate__pulse animate__infinite'>
                                                    <img src={require('../../../assets/images/redeemWalletImg.svg').default} alt='redeemWalletImg' className='img-fluid animate__animated animate__pulse animate__infinite' />
                                                </div>
                                                <div className='rightLevelcnt'>
                                                    <div className='labelTxt'>Wallet Balance</div>
                                                    <div className='labelVal'>{(stakeBalance?.data?.redeemWalletAvailable)?.toString().includes('.') ? formatBalance(stakeBalance?.data?.redeemWalletAvailable) : stakeBalance?.data?.redeemWalletAvailable} <span className='fs-14 fw-400 text-white-60'>TPL</span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-8">
                                            <div className="row rightLevelcnt">
                                                <div className="col-md col-sm-6 mb-md-0 mb-3">
                                                    <div>
                                                        <div className='labelTxt'>Total Stake Reward</div>
                                                        <div className='labelVal'>{(stakeBalance?.data?.totalStakeReward)?.toString().includes('.') ? parseFloat(stakeBalance?.data?.totalStakeReward)?.toFixed(5).replace(/(\.0+)?$/, '') : stakeBalance?.data?.totalStakeReward} <span className='fs-14 fw-400 text-white-60'>TPL</span></div>
                                                    </div>
                                                </div>
                                                <div className="col-md col-sm-6 mb-md-0 mb-3">
                                                    <div>
                                                        <div className='labelTxt'>Total Redeem Amount</div>
                                                        <div className='labelVal'>{(stakeBalance?.data?.totalRedeemed)?.toString().includes('.') ? parseFloat(stakeBalance?.data?.totalRedeemed)?.toFixed(5).replace(/(\.0+)?$/, '') : stakeBalance?.data?.totalRedeemed} <span className='fs-14 fw-400 text-white-60'>TPL</span></div>
                                                    </div>
                                                </div>
                                                <div className="col-md col-sm-6">
                                                    <div>
                                                        <div className='labelTxt'>Global Reward</div>
                                                        <div className='labelVal'>{(stakeBalance?.data?.globalReward)?.toString().includes('.') ? parseFloat(stakeBalance?.data?.globalReward)?.toFixed(5).replace(/(\.0+)?$/, '') : stakeBalance?.data?.globalReward} <span className='fs-14 fw-400 text-white-60'>TPL</span></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card2Head">History</div>

                                <div className="appcard mb-4 px-3 pb-2 cardbg">

                                    <div className='row justify-content-center'>
                                        <div className='col-lg-9'>
                                            <div className='row'>
                                                {redeemWalletTabs.map((item, index) =>
                                                    <div className="col-lg-4 col-md-6" key={item}>
                                                        <Link className='appDarkCard walletCard tabLinkBx mb-3' to={item.navigationto} key={'tab' + index}>
                                                            <button className='btn btnArrowcard' >
                                                                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M8.58881 3.53662L1.28975 9.35339" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                                    <path d="M7.95354 9.15769L8.58881 3.53662" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                                    <path d="M2.96778 2.90159L8.58885 3.53686" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                            </button>
                                                            <div className='wc-name'>{item.tabName}</div>
                                                        </Link>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default RedeemWallet;